'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxSubCatsTable', [])
	.directive('flxSubCatsTable', require('./flxSubCatsTableDirective'))
	.controller('SCTableCtrl', require('./flxSubCatsTableController'))
	;